import { RequestContext } from '@cash-web/protos/squareup/franklin/RequestContextProto.pb'

import { CashRequestMiddleware } from './types'

let blockerDescriptorId: string | undefined

export const requestContextRequest: CashRequestMiddleware = request => {
  if (request.method !== 'GET') {
    const request_context = request?.data?.request_context ?? ({} as RequestContext)
    if (blockerDescriptorId != null) {
      request_context.blocker_descriptor_id = blockerDescriptorId
    }
    if (Object.keys(request_context).length > 0 || (typeof window !== 'undefined' && window.csrfToken != null)) {
      request.data ??= {}
      request.data.request_context = request_context
    }
  }
  return request
}

type BlockerDescriptorIdentifier = { id?: string; groupId?: string }

export const setBlockerDescriptorId = (blockerDescriptorIdentifier: BlockerDescriptorIdentifier) => {
  const { id, groupId } = blockerDescriptorIdentifier

  // If a group ID is present, it takes precedence over the individual blocker ID
  // https://github.com/squareup/cash-web/blob/0cc959d4450e8e0ccf23a83f7cfe8c66aa8d2fb5/libs/npm-packages/protos/types/squareup/franklin/scenarios.pb.ts#L128-L134
  if (groupId) {
    blockerDescriptorId = groupId
    return
  }

  blockerDescriptorId = id
}
